export function setHeader(conf) {
    return (dispatch) => {
        dispatch({ type: 'HEADER:SET_HEADER_MODE', conf });
    };
}
